import actionTypes from './action-types';
import getterTypes from './getter-types';
import mutationTypes from './mutation-types';

export default {
  [actionTypes.UPDATE_CART] ({ commit, dispatch }, cart) {
    // console.log(cart);
    commit(mutationTypes.SET_ORDER_DELIVERY_TYPE, cart.order_delivery_type);
    commit(mutationTypes.SET_CART_GROUPS, cart.cart_groups);
    commit(mutationTypes.SET_ORDER_PAYMENT_TYPES, cart.order_payment_types);
    commit(mutationTypes.SET_ORDER_PAYMENT_TYPE, cart.order_payment_type);
    commit(mutationTypes.SET_FIRSTNAME, cart.firstname);
    commit(mutationTypes.SET_LASTNAME, cart.lastname);
    commit(mutationTypes.SET_EMAIL, cart.email);
    commit(mutationTypes.SET_PHONE, cart.phone);
    commit(mutationTypes.SET_ADDRESS, cart.address);
    commit(mutationTypes.SET_NOTE, cart.note);
    dispatch(actionTypes.UPDATE_CART_INFO, cart);
  },
  [actionTypes.UPDATE_CART_INFO] ({ commit }, cart) {
    commit(mutationTypes.SET_ORDER_DELIVERY_TYPE, cart.order_delivery_type);
    commit(mutationTypes.SET_TOTAL_PRICE, cart.total_price);
    commit(mutationTypes.SET_TOTAL_PRICE_FORMATTED, cart.total_price_formatted);
    commit(mutationTypes.SET_ITEM_PRICE, cart.item_price);
    commit(mutationTypes.SET_ITEM_PRICE_FORMATTED, cart.item_price_formatted);
    commit(mutationTypes.SET_TOTAL_PACKAGING_PRICE, cart.total_packaging_price);
    commit(mutationTypes.SET_TOTAL_PACKAGING_PRICE_FORMATTED, cart.total_packaging_price_formatted);
    commit(mutationTypes.SET_IS_VALID, cart.is_valid);
    commit(mutationTypes.SET_TOTAL_AMOUNT, cart.total_amount);
  },
  [actionTypes.UPDATE_OFFER_MEAL] ({ dispatch, commit, getters }, {offerMeal, amount, ingredients}) {
    return window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/offer-meal', {
      offer_meal_id: offerMeal.id,
      amount: amount,
      ingredients: ingredients
    }).then(response => {
      commit(mutationTypes.SET_CART_GROUPS, response.data.cart.cart_groups);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data.cart);
      return {
        offerMeal: response.data.offer_meal,
        soldOut: response.data.sold_out
      };
    });
  },
  [actionTypes.ADD_OFFER_MEAL] ({ dispatch, commit, getters }, {offerMeal, ingredients}) {
    let amount = 0;
    let line = getters[getterTypes.GET_OFFER_MEAL_CART_LINE](offerMeal);
    if (line) {
      amount = line.amount;
    }
    amount++;
    return window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/offer-meal', {
      offer_meal_id: offerMeal.id,
      amount: amount,
      ingredients: ingredients
    }).then(response => {
      commit(mutationTypes.SET_CART_GROUPS, response.data.cart.cart_groups);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data.cart);
      return {
        offerMeal: response.data.offer_meal,
        soldOut: response.data.sold_out
      };
    });
  },
  [actionTypes.REMOVE_OFFER_MEAL] ({ dispatch, commit, getters }, { offerMeal }) {
    let amount = 0;
    let ingredients = {};
    let line = getters[getterTypes.GET_OFFER_MEAL_CART_LINE](offerMeal);
    if (line) {
      amount = line.amount - 1;
      ingredients = line.data.ingredients;
    }
    return window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/offer-meal', {
      offer_meal_id: offerMeal.id,
      ingredients: ingredients,
      amount: amount
    }).then(response => {
      commit(mutationTypes.SET_CART_GROUPS, response.data.cart.cart_groups);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data.cart);
      return {
        offerMeal: response.data.offer_meal,
        soldOut: response.data.sold_out
      };
    });
  },
  [actionTypes.ADD_LUNCH_MEAL] ({ dispatch, commit, getters }, { lunchMeal, lunchDay }) {
    let amount = 0;
    let line = getters[getterTypes.GET_LUNCH_MEAL_CART_LINE]({
      lunchMeal: lunchMeal,
      lunchDay: lunchDay
    });
    if (line) {
      amount = line.amount;
    }
    amount++;
    return window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/lunch-meal', {
      lunch_meal_id: lunchMeal.id,
      lunch_day_id: lunchDay.id,
      amount: amount
    }).then(response => {
      commit(mutationTypes.SET_CART_GROUPS, response.data.cart.cart_groups);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data.cart);
      return {
        lunchMeal: response.data.lunch_meal,
        soldOut: response.data.sold_out,
      };
    });
  },
  [actionTypes.REMOVE_LUNCH_MEAL] ({ dispatch, commit, getters }, { lunchMeal, lunchDay }) {
    let amount = 0;
    let line = getters[getterTypes.GET_LUNCH_MEAL_CART_LINE]({
      lunchMeal: lunchMeal,
      lunchDay: lunchDay
    });
    if (line) {
      amount = line.amount - 1;
    }
    return window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/lunch-meal', {
      lunch_meal_id: lunchMeal.id,
      lunch_day_id: lunchDay.id,
      amount: amount
    }).then(response => {
      commit(mutationTypes.SET_CART_GROUPS, response.data.cart.cart_groups);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data.cart);
      return {
        lunchMeal: response.data.lunch_meal,
        soldOut: response.data.sold_out,
      };
    });
  },
  [actionTypes.UPDATE_ORDER_DELIVERY_TYPE] ({ dispatch, getters, commit }, type) {
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/order-delivery-type', {
      type: type
    }).then(response => {
      commit(mutationTypes.SET_ORDER_DELIVERY_TYPE, response.data.order_delivery_type);
      commit(mutationTypes.SET_ORDER_PAYMENT_TYPES, response.data.order_payment_types);
      commit(mutationTypes.SET_ORDER_PAYMENT_TYPE, response.data.order_payment_type);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data);
    });
  },
  [actionTypes.UPDATE_ORDER_PAYMENT_TYPE] ({ dispatch, getters, commit }, type) {
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/order-payment-type', {
      type: type
    }).then(response => {
      commit(mutationTypes.SET_ORDER_PAYMENT_TYPE, response.data.order_payment_type);
      dispatch(actionTypes.UPDATE_CART_INFO, response.data);
    });
  },
  [actionTypes.UPDATE_FIRSTNAME] ({ commit, getters }, firstname) {
    commit(mutationTypes.SET_FIRSTNAME, firstname);
    commit(mutationTypes.SET_ERRORS, {firstname: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/firstname', {
      firstname: firstname
    }).then(response => {
      commit(mutationTypes.SET_FIRSTNAME, response.data.firstname);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  },
  [actionTypes.UPDATE_NOTE] ({ commit, getters }, note) {
    commit(mutationTypes.SET_NOTE, note);
    commit(mutationTypes.SET_ERRORS, {note: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/note', {
      note: note
    }).then(response => {
      commit(mutationTypes.SET_NOTE, response.data.note);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  },
  [actionTypes.UPDATE_LASTNAME] ({ commit, getters }, lastname) {
    commit(mutationTypes.SET_LASTNAME, lastname);
    commit(mutationTypes.SET_ERRORS, {lastname: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/lastname', {
      lastname: lastname
    }).then(response => {
      commit(mutationTypes.SET_LASTNAME, response.data.lastname);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  },
  [actionTypes.UPDATE_EMAIL] ({ commit, getters }, email) {
    commit(mutationTypes.SET_EMAIL, email);
    commit(mutationTypes.SET_ERRORS, {email: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/email', {
      email: email
    }).then(response => {
      commit(mutationTypes.SET_EMAIL, response.data.email);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  },
  [actionTypes.UPDATE_PHONE] ({ commit, getters }, phone) {
    commit(mutationTypes.SET_PHONE, phone);
    commit(mutationTypes.SET_ERRORS, {phone: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/phone', {
      phone: phone
    }).then(response => {
      commit(mutationTypes.SET_PHONE, response.data.phone);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  },
  [actionTypes.UPDATE_ADDRESS] ({ commit, getters }, address) {
    commit(mutationTypes.SET_ADDRESS, address);
    commit(mutationTypes.SET_ERRORS, {address: []});
    commit(mutationTypes.SET_IS_VALID, false);
    window.axios.post(getters[getterTypes.GET_UPDATE_CART_URL] + '/address', {
      address: address
    }).then(response => {
      commit(mutationTypes.SET_ADDRESS, response.data.address);
      commit(mutationTypes.SET_IS_VALID, response.data.is_valid);
    }).catch((error) => {
      commit(mutationTypes.SET_ERRORS, error.response.data.errors);
    });
  }
}
